import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { ISearchParam } from "../BaseApp";
import { IUpdateModel } from ".";
import { EmptyUpdateModel } from "./UpdatesApp";

interface IUpdatesState {
    updates: IUpdateModel[],
    selectedUpdates: IUpdateModel[],
    searchParams: ISearchParam[],
    loading: boolean,
    pagination: IDataDisplayerPagination,
    search?: string
}

const initialState: IUpdatesState = {
    updates: [],
    selectedUpdates: [],
    searchParams: [],
    loading: false,
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    }
}

const updatesSlice = createSlice({
    name: "updates",
    initialState,
    reducers: {
        updateAllUpdates: (state: IUpdatesState, action: PayloadAction<IUpdateModel[]>) => {
                state.updates = action.payload
        },
        addNewUpdate: (state: IUpdatesState, action: PayloadAction<IUpdateModel>) => {
            let updates = state.updates

            if (updates.filter(update => update.id === action.payload.id).length === 0){
                state.updates.push(action.payload)
            }

        },
        deleteUpdate: (state: IUpdatesState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let updates = state.updates

            updates = updates.filter(update => update.id !== payload.id)

            state.updates = updates

        },
        updateUpdate: (state: IUpdatesState, action: PayloadAction<IUpdateModel>) => {
            let updates = state.updates
            
            if (updates && updates.length > 0){
                updates.map((update) => {
                    if (update.id === action.payload.id){

                        const locationIndex = updates.findIndex(update => update.id === action.payload.id)
                        updates[locationIndex] = action.payload

                    }
                })
            }

            state.updates = updates

        },
        updateUpdatesLoadingStatus: (state: IUpdatesState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateUpdatesPagination: (state: IUpdatesState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateUpdatesSearch: (state: IUpdatesState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        updateUpdatesSearchParams: (state: IUpdatesState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
        setSelectedUpdates: (state: IUpdatesState, action: PayloadAction<IUpdateModel[]>) => {
            state.selectedUpdates = action.payload
        },
    }
})

/**
 * Return all update
 */
export const useReturnAllUpdates = () => useSelector((state: RootState) => state.updates.updates)

/**
 * Retrun single update
 */
export const useReturnSingleUpdate = (id: number) => {
    const updates = useReturnAllUpdates()

    let update: IUpdateModel = EmptyUpdateModel

    if (updates.length > 0){
        updates.map((singleUpdate) => {
            if (singleUpdate.id === id){
                update = singleUpdate
            }
        })
    }

    return update

}

/**
 * Return updates loading status
 */
export const useReturnUpdatesLoadingStatus = () => useSelector((state: RootState) => state.updates.loading)

/**
 * Return updates pagination
 */
export const useReturnUpdatesPagination = () => useSelector((state: RootState) => state.updates.pagination)

/**
 * Return updates search
 */
export const useReturnUpdatesSearch = () => useSelector((state: RootState) => state.updates.search)

/**
 * Return updates search params
 */
export const useReturnUpdatesSearchParams = () => useSelector((state: RootState) => state.updates.searchParams)

/**
 * Return selected updates
 */
export const useReturnSelectedUpdates = () => useSelector((state: RootState) => state.updates.selectedUpdates)

export const { updateAllUpdates, addNewUpdate, deleteUpdate, updateUpdate, updateUpdatesLoadingStatus, updateUpdatesPagination, updateUpdatesSearch, updateUpdatesSearchParams, setSelectedUpdates } = updatesSlice.actions
export default updatesSlice.reducer